export default __webpack_public_path__ + "static/media/SEC.c86d7637.png";